import { render, staticRenderFns } from "./wechatPay.vue?vue&type=template&id=71fb7372&scoped=true&"
import script from "./wechatPay.vue?vue&type=script&lang=js&"
export * from "./wechatPay.vue?vue&type=script&lang=js&"
import style0 from "./wechatPay.vue?vue&type=style&index=0&id=71fb7372&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fb7372",
  null
  
)

export default component.exports